// This is the right side of the figma
// https://www.figma.com/proto/ITEOBzG70wVkwRkep3rc0B/Tracer---Ant-Design?page-id=9316%3A23734&node-id=9613-21823&node-type=frame&viewport=-64%2C334%2C0.12&t=KPS4u8Suia3eGyRO-1&scaling=contain&content-scaling=fixed&starting-point-node-id=9607%3A15334
// If the issue and potentiallIssues are both null we list issues to select.
// If the issue is null but we have potentialIssues, we are here from an
//   "n issues" button and list them and allow linking the fault to the issue, as
//   well as an "Add Issue" button to create a new one.
// If the issue is not null we are adding (if the issue has no id) or editing
// All of the above is abstracted into the showList prop
import { useEffect, useState } from 'react'
import { IssueEditForm } from './IssueEditForm'
import { IssueList } from './IssueList'
import { useUserInfo } from '../hooks/User'
import { Input, Flex } from 'antd'
import { useFetchNewIssueIdForProblemLog } from '../hooks/Issues'
import { buildFaultDescription } from './utils'

//   (if the issue has an ID), and we should list fault details here
export const IssueSummary = ({
  fault,
  issue,
  potentialIssues,
  setIssue,
  setFault,
  showList,
  defaultIssueId,
  intl,
}) => {
  const { userInfo } = useUserInfo()
  const [issueId, setIssueId] = useState(null)
  const [description, setDescription] = useState('')
  const fetchNewIssueIDForPL = useFetchNewIssueIdForProblemLog()
  useEffect(() => {
    if (issue && issue.id) {
      setIssueId(issue.id)
      setDescription(issue.description)
    } else if (fault && fault.id && issue && issue.issue_category_id) {
      setDescription(buildFaultDescription(fault))
      fetchNewIssueIDForPL.mutate(
        {
          problem_log_id: fault.id,
          issue_category_id: issue.issue_category_id,
        },
        {
          onSuccess: (issId) => {
            setIssueId(issId)
          },
        },
      )
    } else if (!issue?.issue_category_id) {
      setIssueId(null)
    }
  }, [issue?.id, issue?.issue_category_id, fault?.id])

  const updateIssueDesc = (desc) => {
    setDescription(desc)
    issue.description = desc
    setIssue(issue)
  }

  return (
    <Flex id="issue-summary" vertical={true} gap={10}>
      {!showList && (
        <Flex id="issue-preview" vertical={true} gap={7}>
          <div>{issueId}:</div>
          <Input
            id="issue-description-input"
            value={description}
            onChange={(evt) => {
              updateIssueDesc(evt.target.value)
            }}
          />
          {!!issue.created_by && (
            <span id="issue-by">By {issue.created_by}</span>
          )}
          {userInfo && !issue.id && (
            <span id="issue-by">By {userInfo.username}</span>
          )}
        </Flex>
      )}
      {!showList && (
        <IssueEditForm
          orientation="vertical"
          issue={issue}
          setIssue={setIssue}
          fault={fault}
          readOnly={true}
          showFaultDetails={true}
          intl={intl}
          setFault={setFault}
        />
      )}
      {showList && (
        <IssueList
          fault={fault}
          issues={potentialIssues}
          setIssue={setIssue}
          setFault={setFault}
          defaultIssueId={defaultIssueId}
          intl={intl}
        />
      )}
    </Flex>
  )
}
